export default "__VITE_ASSET__1puOUjmj__"